import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router";
import { useLinks, useMissionRoleTemplate } from "hooks";
import { Grid, PageWrapper } from "components/Containers";
import PageTitle from "components/PageTitle";
import Card from "components/Card";
import { BackLink } from "components/Links";
import { BlueprintEditModal, BlueprintSummary } from "components/Blueprints";
import { BlueprintVetting } from "components/Missions/Roles/TalentSimple/RoleBuilder";
import { GET_MISSION_ROLE_TEMPLATE } from "graphql/queries";

/**
 * Blueprint Setting
 */
const BlueprintSetting = () => {
  const { uuid } = useParams();
  const links = useLinks();
  const [showEditForm, setShowEditForm] = useState(false);
  const { template, loading, refetch } = useMissionRoleTemplate({ id: uuid });

  return (
    <PageWrapper>
      <Helmet>
        <title>{template?.name}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle
            subtitle={template?.name}
            loading={loading}
            backLink={
              <BackLink to={links.settings_blueprints} routerEnabled>
                <FormattedMessage id="Settings.Blueprints.Title" />
              </BackLink>
            }
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <Card>
            <BlueprintSummary template={template} loading={loading} onEdit={() => setShowEditForm(true)} />
          </Card>
        </Grid.col>
        <Grid.col start={1} end={13}>
          <BlueprintVetting
            role={template}
            loading={loading}
            refetch={refetch}
            refetchQueries={[GET_MISSION_ROLE_TEMPLATE]}
            canRemoveRequirements
            canGenerateQuestionsWithAI={false}
          />
        </Grid.col>
      </Grid>
      <BlueprintEditModal
        template={template}
        show={showEditForm}
        onClose={() => setShowEditForm(false)}
        refetchQueries={[GET_MISSION_ROLE_TEMPLATE]}
      />
    </PageWrapper>
  );
};

export default BlueprintSetting;
